import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule, getLocaleFirstDayOfWeek } from '@angular/common';
import { ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet, Router, NavigationStart } from '@angular/router';
import { CentralService } from '../../../services/central.service';
import { MedclassButtonComponent } from '../../components/medclass-button/medclass-button.component';
import { FormsModule } from '@angular/forms';
import { Listado } from "../../../services/listado.service";
import { PrevCardComponent } from "../../components/prev-card/prev-card.component";
import { Subscription } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { jwtDecode } from "jwt-decode";
import { environment } from '../../../environments/enviroment';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    CommonModule,
    MedclassButtonComponent,
    FormsModule,
    MatIconModule,
    PrevCardComponent,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})


export class HeaderComponent implements OnInit, OnDestroy {
  constructor(private centralService: CentralService,
              private router: Router,
              private listadoService: Listado,
              private actualRoute:ActivatedRoute) {
              this.router.events.subscribe(event => {
                  if (event instanceof NavigationStart) {
                    // Se inicia la navegación
                    //console.log('Navegación iniciada');
                    if (this.busquedaActiva) {
                      this.toggleBusqueda('close');
                    }

                    if (this.menuActive) {
                      this.toggleMenuMovil('close');
                    }
                  }
                });
               }
  
  @ViewChild('inputBusquedaHeader') inputBusqueda?: ElementRef;
  @Input() logged: boolean = false;
  @Input() webinarActivo: any = false;
  isInputFocused = false;
  usuarioRepresentante:boolean = false;
  array_rolUsuario:string[] = [];
  contenidoEspecial:string = '';
  hasAvailableShorts: boolean = false;
  readonly shortsEnabled = environment.shortsEnabled;
  temporalNMStoken:string = ''; //Variable temporal para DEV - NUMEN

  subscriptions: Subscription[] = [];

  puedeRegistrar(usuario:any){
    return this.centralService.puedeRegistrar();
  }

  permisoRegistrar : boolean = false
  
  private getTokenRoles(): string[] {
    const token = localStorage.getItem('token');
    if (!token) return [];

    try {
      const decoded: any = jwtDecode(token);
      const tokenRoleFields = [
        decoded?.UserTypeArray,
        decoded?.role,
        decoded?.roles,
        decoded?.authorities,
        decoded?.usertype,
        decoded?.user_type,
        decoded?.userTypeArray,
        decoded?.user_type_array,
        decoded?.userTypes,
        decoded?.userType
      ];

      return this.extractRoleTokens(tokenRoleFields);
    } catch {
      return [];
    }
  }

  private normalizeRole(value: string): string {
    return (value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\s_-]+/g, '')
      .trim()
      .toLowerCase();
  }

  private extractRoleTokens(value: any): string[] {
    if (Array.isArray(value)) {
      return value.flatMap(item => this.extractRoleTokens(item));
    }

    if (value && typeof value === 'object') {
      return Object.values(value).flatMap(item => this.extractRoleTokens(item));
    }

    if (typeof value === 'string') {
      const raw = value.trim();
      if (!raw) return [];

      try {
        const parsed = JSON.parse(raw);
        if (parsed !== value) {
          return this.extractRoleTokens(parsed);
        }
      } catch {
        // no-op
      }

      return raw.match(/[A-Za-zÁÉÍÓÚáéíóúÑñ]+/g) || [];
    }

    return [];
  }

  private getAllRoles(): string[] {
    const sources = [
      this.array_rolUsuario,
      this.centralService.usuario?.UserTypeArray,
      localStorage.getItem('userTypeArray'),
      this.getTokenRoles()
    ];

    return sources
      .flatMap(source => this.extractRoleTokens(source))
      .map(role => this.normalizeRole(role))
      .filter(role => role.length > 0);
  }

  shouldShowCapsulas(): boolean {
    if (!this.logged) return false;
    if (window.location.pathname === '/') return false;

    const currentRoles = this.getAllRoles();
    if (!currentRoles.length) return false;

    const blockedRoles = new Set([
      'representantelatam',
      'medicolatam'
    ]);

    const hasBlockedRole = currentRoles.some(role => blockedRoles.has(role));

    return !hasBlockedRole;
  }

  shouldShowPuntoCima(): boolean {
    return this.logged
      && this.centralService.isPuntoCimaUser([
        this.array_rolUsuario,
        this.getTokenRoles()
      ]);
  }

  ngOnInit(): void {
    const usuarioSubscription =
      this.centralService.usuario$.subscribe((usuario: any) => {
        if (usuario) {
          this.array_rolUsuario = usuario.UserTypeArray || [];
          this.usuarioRepresentante = this.puedeRegistrar(usuario);

          if (this.shortsEnabled) {
            const shortsAvailabilitySubscription = this.listadoService
              .hasAvailableShorts(usuario._id)
              .subscribe(hasAvailableShorts => {
                this.hasAvailableShorts = hasAvailableShorts;
              });

            this.subscriptions.push(shortsAvailabilitySubscription);
          } else {
            this.hasAvailableShorts = false;
          }
        } else {
          this.hasAvailableShorts = false;
        }
      });
  
    const contenidoEspecialSubscription =
      this.centralService.contenidoEspecial$.subscribe((contenidoEsp: any) => {
        this.contenidoEspecial = contenidoEsp;
      });
  
    this.subscriptions.push(usuarioSubscription, contenidoEspecialSubscription);
  
    if (this.centralService.tieneToken()) {
      this.notificacionesArr = [];
      this.centralService.getNotificacion().subscribe((res: any) => {
        this.notificacionesArr = res.data;
        if (localStorage.getItem('notificacionesIds')) {
          this.notificactioOn = this.compruebaNotificaciones();
        } else if (this.notificacionesArr.length > 0) {
          this.notificactioOn = true;
        }
      });
  
      const contenidoEspecial = localStorage.getItem('contenidoEspecial');
      console.log('cont esp', contenidoEspecial);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
  

  tipoContenido:any;

  menuActive:boolean = false;

  transmisionEnVivo: boolean = false;

  toggleMenuMovil(type?:string){

    if (type == 'close') {
      this.menuActive = false;  
    }else{
      this.menuActive = !this.menuActive;
    }
    
    document.body.classList.toggle('block-overflow'); 
  }

  compruebaNotificaciones() {
    // Obtener la cadena de IDs desde el almacenamiento local
    const idsString = localStorage.getItem('notificacionesIds')!;
  
    // Convertir la cadena de texto a un array de IDs
    const idsArray = JSON.parse(idsString) || []; // Si no hay nada en el localStorage, usar un array vacío
  
    // Iterar sobre las nuevas notificaciones
    for (let i = 0; i < this.notificacionesArr.length; i++) {
      const notificacionId = this.notificacionesArr[i]._id;
      
      // Verificar si el ID de la notificación actual no está presente en las notificaciones guardadas
      if (!idsArray.includes(notificacionId)) {
        return true; // Si encuentra al menos una nueva notificación, devuelve true
      }
    }
  
    // Si no encuentra ninguna nueva notificación, devuelve false
    return false;
  }

  storeNotificaciones(){
    // for (let i = 0; i < this.notificacionesArr.length; i++) {
    //   const notificacionId = this.notificacionesArr[i]._id;
    //   //console.log( notificacionId);
    // }

    // Convertir el array de IDs a una cadena de texto
    const idsString = JSON.stringify(this.notificacionesArr.map(notificacion => notificacion._id));

    // Guardar la cadena en el almacenamiento local
    localStorage.setItem('notificacionesIds', idsString);
  }

  navFromNotifiacion(idContenido:string, categoria:string){
    const categoriaContenido = categoria.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    const url = `contenido/${categoriaContenido}/${idContenido}`;
    //console.log(url);
    this.router.navigateByUrl(url);
    this.notificactioActive = !this.notificactioActive;
  }


  notificacionesArr:any[] = []

  busquedaActiva:boolean = false;
  sinResultados:boolean = false;
  showResultados:boolean = false;

  busqueda:string = '';

  listaResultados: any[] = [];

  notificactioOn:boolean = false;
  notificactioActive:boolean = false;


  // user:any = {
  //   name: 'Usuario',
  //   id: '63a4d7e40a0301ffe0c9090c',
  //   token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2M2E0ZDdlNDBhMDMwMWZmZTBjOTA5MGMiLCJyb2xlIjpbImFkbWluIl0sImlhdCI6MTcwNjAzNjk1MSwiZXhwIjoxNzA2MDY1NzUxfQ.WoI2chlYA3giuQoru5Gs7evUpQFXe70xUrgQ2aduZmE',
  //   imgPerfil: ''
  // };

  get user(){
    return this.centralService.usuario
  }

  reloadRoute(url: string) {
    // Navegar a una ruta temporal antes de volver a la original
    this.router.navigateByUrl('/dummy', { skipLocationChange: true }).then(() => {
      this.router.navigateByUrl(url);
    });
  }

  clearBusqueda(){
    this.inputBusqueda?.nativeElement.focus();
    this.busqueda = '';

  }

  abrirNotificacion(){
    if (this.busquedaActiva) {
      this.busquedaActiva = false;
    }
    
    this.notificactioOn = false;
    this.notificactioActive = !this.notificactioActive;
    this.storeNotificaciones()
  }

  onEnterKey() {
    if (this.isInputFocused && this.busqueda !== '') {
      this.buscar();
    }
  }

  onInputFocus() {
    this.isInputFocused = true;
  }

  onInputBlur() {
    this.isInputFocused = false;
  }

  buscar(){
    //console.log(this.busqueda);
    const currentUrl = this.router.url;
    if (this.busqueda.trim() !== '') {
      this.router.navigate(['/busqueda'], { queryParams: { q: this.busqueda, returnUrl: currentUrl } });
    }
    

    // this.showResultados = false;
    // this.listadoService.getResultadosBusqueda( this.busqueda, this.centralService.usuario._id).subscribe((resultados:any) => {
    //   //console.log(resultados);
    //   //console.log('---FORMAT---');
    //   // //console.log(this.formatBusqueda(resultados));
    //   this.showResultados = true;
    //   this.listaResultados = this.formatBusqueda(resultados)
    //   if (this.listaResultados.length == 0) {
    //     this.sinResultados = true
    //   }else{
    //     this.sinResultados = false;
    //   }
    //   document.body.classList.toggle('block-overflow'); 
      
      
    // })
  }

  toggleBusqueda(type?:string){
    this.busquedaActiva = type == 'close' ? false : !this.busquedaActiva;
    // this.busquedaActiva = !this.busquedaActiva;
    // if (this.showResultados) {
    //   this.showResultados = false;
    //   document.body.classList.toggle('block-overflow'); 
    // }

    if (this.notificactioActive) {
      this.notificactioActive = false;
    }
    
    this.busqueda = '';
    this.inputBusqueda?.nativeElement.focus();
  }

  iniciarSesion(){
    this.router.navigateByUrl('/login');
    this.centralService.login(this.temporalNMStoken).subscribe({
      next: () => {
        this.router.navigateByUrl('/inicio');
      },
      error: () => this.centralService.disparaToast('No se pudo iniciar sesión. Intente de nuevo.', true)
    });
  }

  cerrarSesion(){
    this.centralService.logout();
    this.router.navigateByUrl('/bienvenida');
  }

  formatBusqueda(ok:any){

    let lista = []

    for (const categoria in ok) {
      if (ok.hasOwnProperty(categoria)) {
          // //console.log(`Categoría: ${categoria}`);
  
          // Recorriendo los elementos de la categoría
          for (const elemento of ok[categoria]) {
              // //console.log(elemento);
              let obj = {};
              let progresoPorcentaje = '';

              switch (categoria) {
                case 'masterclass':
                  obj = {
                    titulo: elemento.titulo,
                    autor: elemento.doctor,
                    descripcion: elemento.descripcion,
                    duracion: elemento.duracion,
                    numReproducciones: elemento.visitas,
                    categoria: "Masterclass",
                    imagen: elemento.imagen_portada.url,
                    areaTer: elemento.area_terapeutica,
                    fecha: elemento.fecha_registro,
                    id:elemento._id
                  }

                  lista.push(obj)

                  break;

                case 'capsulas':

                  obj = {
                    titulo: elemento.titulo,
                    autor: elemento.doctor,
                    descripcion: elemento.descripcion,
                    duracion: elemento.duracion,
                    numReproducciones: elemento.visitas,
                    categoria: 'Cápsula',
                    imagen: elemento.imagen_portada.url,
                    areaTer: elemento.area_terapeutica,
                    fecha: elemento.fecha_registro,
                    id:elemento.id_contenido
                  }

                  lista.push(obj)
                  
                  break;

                case 'retransmisiones':
                  
                  obj = {
                    titulo: elemento.titulo,
                    autor: elemento.doctor,
                    descripcion: elemento.descripcion,
                    duracion: elemento.duracion,
                    numReproducciones: elemento.visitas,
                    categoria: 'Retransmisión',
                    imagen: elemento.imagen_portada.url,
                    areaTer: elemento.area_terapeutica,
                    fecha: elemento.fecha_registro,
                    id:elemento.id_contenido
                  }

                  lista.push(obj)
                  
                  break;

                case 'podcasts':
                  
                  obj = {
                    titulo: elemento.titulo,
                    autor: elemento.doctor,
                    descripcion: elemento.descripcion,
                    duracion: elemento.duracion,
                    numReproducciones: elemento.visitas,
                    categoria: 'Podcast',
                    imagen: elemento.imagen_portada.url,
                    areaTer: elemento.area_terapeutica,
                    fecha: elemento.fecha_registro,
                    id:elemento.id_contenido
                  }

                  lista.push(obj)
                  
                  break;
              
                default:
                  break;
              }
          }
      }
    }
    // //console.log(lista);
    
    return lista;

  }


}
